import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const defaultErrorMessage = "An error has occurred";

export interface ICommonStoreState{
  error: {
    isOpen: boolean;
    message: string;
    debugInfo?: string[];
    timestamp: number | null;
  }
}

const initialState: ICommonStoreState = {
  error:{
    isOpen: false,
    message: defaultErrorMessage,
    debugInfo: [],
    timestamp: null,
  }
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: (create) => ({
    errorReducer: create.reducer((state, action: PayloadAction<{isOpen: boolean, message: string, debugInfo?: string[], timestamp: number | null}>) => {
      state.error = {...state.error, isOpen: action.payload.isOpen, message: action.payload.message, debugInfo: action.payload.debugInfo, timestamp: action.payload.timestamp};
    }),
  }),
  selectors: {
    errorMessageSelector: (state: ICommonStoreState) => state.error,
  }
});

export const commonReducer = commonSlice.reducer;